import { makeSelectAppLoggedIn, makeSelectAppLoggedInProcess, } from "../../app/appSelectors";
import { useDispatch, useSelector } from "react-redux";
import { LoginBoxStyled, LoginStyled } from "../Login/styled/LoginStyled";
import LoginWrapper from "../../modules/Login/components/LoginWrapper";
import { URL_SEARCH_PARAMS } from "../../app/appConstants";
import { Loader } from "../../components/Loader/Loader";
import Registration from "../../modules/Login/components/Registration";
import { useCallback } from 'react';
import { registrationPrepareAction } from "../../modules/Login/loginActions";
import LocationRedirectToOriginPage from '../../modules/Location/components/LocationRedirectToOriginPage';

export const REGISTRATION_URL_INITIAL_PARAMS = [
    URL_SEARCH_PARAMS.EMAIL,
    URL_SEARCH_PARAMS.PHONE,
];

function RegistrationPage() {
    const loggedInProcess = useSelector(makeSelectAppLoggedInProcess());
    const isLoggedIn = useSelector(makeSelectAppLoggedIn());
    const dispatch = useDispatch();

    const registrationPrepare = useCallback((payload) => {
        dispatch(registrationPrepareAction(payload))
    }, [dispatch]);

    if (isLoggedIn) {
        return <LocationRedirectToOriginPage/>
    }

    return <LoginWrapper hideAuthButton>
        <LoginStyled>
            <LoginBoxStyled>
                <Registration registrationPrepare={registrationPrepare}/>
                <Loader show={loggedInProcess}/>
            </LoginBoxStyled>
        </LoginStyled>
    </LoginWrapper>
}

export default RegistrationPage;
